"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityBubbleImage = exports.EntityBubbleImageDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var coalesce_1 = require("../../utils/coalesce");
var entity_type_icon_1 = require("./entity-type-icon");
var image_bubble_1 = require("../elements/image-bubble");
var icon_1 = require("../elements/icon");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var is_valid_image_url_1 = require("../../utils/is-valid-image-url");
exports.EntityBubbleImageDefaultProps = {
  size: 48,
  imagePaths: ['openGraph.image.thumbnails.small', 'openGraph.image', 'image']
};
// -------- Styles -------->
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    ", "\n\n    ", "\n\n  "], ["\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    ", "\n\n    ", "\n\n  "])), theme_1.theme.COLOR('line-semi-subtle'), function (props) {
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      img {\n        object-fit: ", ";\n      }\n    "], ["\n      img {\n        object-fit: ", ";\n      }\n    "])), props.fit);
  }, function (props) {
    return props.fit === 'contain' && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: #FFF;\n      img {\n        padding: ", ";\n        width: calc(100% - ", ");\n        max-width: calc(100% - ", ");\n        height: calc(100% - ", ");\n        max-height: calc(100% - ", ");\n      }\n    "], ["\n      background-color: #FFF;\n      img {\n        padding: ", ";\n        width: calc(100% - ", ");\n        max-width: calc(100% - ", ");\n        height: calc(100% - ", ");\n        max-height: calc(100% - ", ");\n      }\n    "])), theme_1.theme.UNIT(props.inset), theme_1.theme.UNIT(props.inset * 2), theme_1.theme.UNIT(props.inset * 2), theme_1.theme.UNIT(props.inset * 2), theme_1.theme.UNIT(props.inset * 2));
  })
});
// -------- Components -------->
var My = {
  Image: (0, styled_components_1.default)(image_bubble_1.ImageBubble)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  TypeIcon: (0, styled_components_1.default)(entity_type_icon_1.EntityTypeIcon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var EntityBubbleImage = function (props) {
  var className = props.className,
    entity = props.entity,
    size = props.size,
    alwaysShowIcon = props.alwaysShowIcon,
    imagePaths = props.imagePaths;
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var image = (0, coalesce_1.coalesce)(entity, imagePaths);
  var hasImage = image && image.url && (0, is_valid_image_url_1.isValidImageUrl)(image.url);
  var imageStyle = props.imageStyle || defn.imageStyle;
  var objectFit = imageStyle === 'logo' ? 'contain' : 'cover';
  var cn = "sh-entity-bubble-image ".concat(className);
  var EntityIcon = entity && entity.__icon;
  var inset = defn.imageInset || props.inset || Math.ceil(size / 50);
  var icon = EntityIcon ? react_1.default.createElement(My.Icon, {
    className: className,
    size: size
  }, react_1.default.createElement(EntityIcon, null)) : react_1.default.createElement(My.TypeIcon, {
    className: className,
    size: size,
    entityTypeName: defn.name
  });
  return !alwaysShowIcon && hasImage ? react_1.default.createElement(My.Image, {
    inset: inset,
    fit: objectFit,
    className: cn,
    size: size,
    image: image
  }) : icon;
};
exports.EntityBubbleImage = EntityBubbleImage;
exports.EntityBubbleImage.defaultProps = exports.EntityBubbleImageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;